"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = exports.moveTo = exports.create = exports.getAll = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(x, y, toSay, layer) {
    // underPerf.recordCreate('floating-text')
    if (layer === void 0) { layer = null; }
    var id = -1; // createId()
    if (!layer) {
        layer = voyageLayers_sidecar_1.voyageLayers.getLayers().uiOnCam;
    }
    // let text = stevieTexts2.create(echoFonts.getData().font4, x, y, layer)
    // stevieTexts2.setText(text, toSay)
    // stevieTexts2.setScale(text, 4)
    var obj = {
        eType: 'goat-misc',
        id: id,
        idLoaded: 0,
        isDead: false,
        text: toSay,
        timeSecMax: 2.5,
        timeSecElapsed: 0,
        x: x,
        y: y,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveTo(obj, x, y) {
    obj.x = x;
    obj.y = y;
    // stevieTexts2.moveTo(obj.text, x, y)
}
exports.moveTo = moveTo;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        // stevieTexts2.kill(c.text)
    });
}
exports.updateAll = updateAll;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDelta();
    obj.timeSecElapsed += ds;
    moveTo(obj, obj.x, obj.y - ds * 20);
    var d = obj.timeSecMax - obj.timeSecElapsed;
    d = mathUtils_sidecar_1.mathUtils.clamp(d, 0, 1);
    // if (d < 1 && d > 0) {
    //   stevieTexts2.setAlpha(obj.text, d)
    // }
    if (obj.timeSecElapsed > obj.timeSecMax) {
        obj.isDead = true;
    }
    diveFont_sidecar_1.diveFont.writeAbsolute(voyageCamera_sidecar_1.voyageCamera.applyCamX(obj.x), voyageCamera_sidecar_1.voyageCamera.applyCamY(obj.y), obj.text, 1, diveColors_1.getWhiteAlpha(d)); // diveColors.pureWhite)
    // rogueGlyphs.write
}
